import React, { useState } from "react";
import { Box, Tooltip, Avatar } from "@mui/material";
// FASE 05 — 6ª validação/PO (item 6): o placeholder "sem imagem" era um ícone de lupa
// (SearchIcon), que o PO leu como um botão de busca. Trocado por um ícone neutro de
// "imagem indisponível". A miniatura real segue aparecendo quando o produto tem imagem.
import { ImageNotSupportedOutlined as SemImagemIcon } from "@mui/icons-material";

interface ImageThumbnailProps {
  urlImagem?: string;
  temImagem: boolean;
  alt?: string;
}

export const ImageThumbnail: React.FC<ImageThumbnailProps> = ({
  urlImagem,
  temImagem,
  alt = "Imagem do produto",
}) => {
  const [imageError, setImageError] = useState(false);

  // Fallback: sem imagem
  if (!temImagem || !urlImagem || imageError) {
    return (
      <Tooltip title="Sem figura disponível" arrow placement="right">
        <Box
          sx={{
            width: 70,
            height: 70,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "transparent", // Herda a cor da linha
            borderRadius: 1,
            border: "1px solid #e0e0e0",
          }}
        >
          <SemImagemIcon sx={{ color: "#bdbdbd", fontSize: 26 }} />
        </Box>
      </Tooltip>
    );
  }

  // Miniatura com ampliação no hover
  return (
    <Tooltip
      title={
        <Box
          component="img"
          src={urlImagem}
          alt={alt}
          sx={{
            width: "300px",
            maxHeight: "400px",
            objectFit: "contain",
            display: "block",
            backgroundColor: "#fff",
            borderRadius: 1,
          }}
        />
      }
      arrow
      placement="right"
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: "transparent",
            padding: 0,
            boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
            maxWidth: "none",
          },
        },
        arrow: {
          sx: {
            color: "#fff",
          },
        },
      }}
    >
      <Box
        component="img"
        src={urlImagem}
        alt={alt}
        onError={() => setImageError(true)}
        sx={{
          width: 70,
          height: 70,
          objectFit: "contain",
          cursor: "pointer",
          backgroundColor: "transparent", // Herda a cor da linha
          borderRadius: 1,
          padding: 0.5,
          border: "1px solid",
          borderColor: "grey.300",
          "&:hover": {
            borderColor: "primary.main",
          },
        }}
      />
    </Tooltip>
  );
};
